// extracted by mini-css-extract-plugin
module.exports = {"formAddButton":"ContactFormContactPersons_formAddButton__BfQYL","title":"ContactFormContactPersons_title__2n0iW","message_block":"ContactFormContactPersons_message_block__36jhy"};